import { ENV } from 'utils/config';
import { treezLoginPageUrl } from 'utils/urlGenerator';

const ATTEMPTS_KEY = 'silent_login_attempts';
const SUPPRESSED_KEY = 'silent_login_suppressed';
const ATTEMPT_WINDOW_MS = 30_000;
const MAX_ATTEMPTS_PER_WINDOW = 2;

type Attempts = { first: number; count: number };

const readAttempts = (): Attempts | null => {
  try {
    const raw = sessionStorage.getItem(ATTEMPTS_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (
      typeof parsed?.first === 'number' &&
      typeof parsed?.count === 'number'
    ) {
      return parsed;
    }
    return null;
  } catch (e) {
    return null;
  }
};

export const claimSilentLoginAttempt = (): boolean => {
  try {
    if (sessionStorage.getItem(SUPPRESSED_KEY)) return false;

    const now = Date.now();
    const previous = readAttempts();
    const withinWindow = previous && now - previous.first < ATTEMPT_WINDOW_MS;

    if (withinWindow && previous.count >= MAX_ATTEMPTS_PER_WINDOW) return false;

    const next: Attempts = withinWindow
      ? { first: previous.first, count: previous.count + 1 }
      : { first: now, count: 1 };

    sessionStorage.setItem(ATTEMPTS_KEY, JSON.stringify(next));
    return true;
  } catch (e) {
    return false;
  }
};

export const suppressSilentLogin = (): void => {
  try {
    sessionStorage.setItem(SUPPRESSED_KEY, 'true');
  } catch (e) {}
};

export const resetSilentLogin = (): void => {
  try {
    sessionStorage.removeItem(ATTEMPTS_KEY);
    sessionStorage.removeItem(SUPPRESSED_KEY);
  } catch (e) {}
};

/**
 * Redirects user to Treez SSO login page with current URL as callback.
 * After successful authentication, user is redirected back to the current page.
 */
const redirectToLogin = () => {
  const currentUrl = `${window?.location?.protocol}//${window?.location.host}${window?.location?.pathname}`;
  const env = ENV || 'production';
  const loginUrl = `${treezLoginPageUrl(env)}/?application=MSO&callback=${currentUrl}&authorize=true`;

  window.location.assign(loginUrl);
};

export default redirectToLogin;
